import React, { Fragment, useEffect, useState } from 'react';

export const Pagination = ({ onChangePage, totalCount, pageSize }) => {
  const pageLimit = 5;
  const [maxPageNumberLimit, setMaxPageLimit] = useState(5);
  const [minimumPageNumberLimit, setMinimumPageNumberLimit] = useState(0);
  const [maxPage, setMaxPage] = useState(0);

  const [pageNumbers, setPageNumbers] = useState([]);
  const [reversedNumbers, setReverseNumbers] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);

  const [checkLastPageActive, setcheckLastPageActive] = useState(false);
  const [checkFirstPageActive, setcheckFirstPageActive] = useState(false);

  useEffect(() => {
    const newPageNumbers = [];
    const newReverseNumbers = [];
    for (let i = 1; i <= maxPage; i++) {
      newPageNumbers.push(i);
    }
    for (let i = maxPage; i >= 1; i--) {
      newReverseNumbers.push(i);
    }
    setPageNumbers(newPageNumbers);
    setReverseNumbers(newReverseNumbers);
  }, [maxPage]);

  useEffect(() => {
    setMaxPage(Math.ceil(totalCount / pageSize));
  }, [totalCount]);

  const changePageBackwards = (page) => {
    if (maxPage >= page) {
      onChangePage(page);
      setPageIndex(page);
    }

    if (page <= minimumPageNumberLimit && pageIndex > page) {
      setMaxPageLimit(maxPageNumberLimit - pageLimit);
      setMinimumPageNumberLimit(minimumPageNumberLimit - pageLimit);
    }
  };

  const changePageForward = (page) => {
    if (maxPage >= page) {
      onChangePage(page);
      setPageIndex(page);
    }

    if (page > maxPageNumberLimit && pageIndex < page) {
      setMaxPageLimit(maxPageNumberLimit + pageLimit);
      setMinimumPageNumberLimit(minimumPageNumberLimit + pageLimit);
    }
    if (page > maxPage && page > maxPageNumberLimit) {
      changeToLastPage(maxPage);
    }
  };

  const changePage = (page) => {
    if (maxPage >= page) {
      onChangePage(page);
      setPageIndex(page);
    }
  };

  const changeToLastPage = (page) => {
    if (maxPage >= page) {
      onChangePage(page);
      setPageIndex(page);

      setMaxPageLimit(
        reversedNumbers.find((ele) => ele % pageLimit == 0) + pageLimit
      );
      setMinimumPageNumberLimit(
        reversedNumbers.find((ele) => ele % pageLimit == 0)
      );
    }
  };

  const changeToFirstPage = (page) => {
    if (maxPage >= page) {
      onChangePage(page);
      setPageIndex(page);

      setMaxPageLimit(pageLimit);
      setMinimumPageNumberLimit(0);
    }
  };
  useEffect(() => {
    if (
      pageIndex > pageLimit &&
      pageIndex <= reversedNumbers.find((ele) => ele % pageLimit == 0)
    ) {
      setcheckLastPageActive(true);
    } else {
      setcheckLastPageActive(false);
    }
  }, [pageIndex]);

  useEffect(() => {
    if (pageIndex > pageLimit) {
      setcheckFirstPageActive(true);
    } else {
      setcheckFirstPageActive(false);
    }
  }, [pageIndex]);

  return (
    <div className="paginationContainer">
      <button
        className="paginationButton"
        onClick={() => changePageBackwards(pageIndex - 1)}
        disabled={pageIndex <= 1}
      >
        {'<<'}
      </button>
      <button
        className="paginationButton"
        onClick={() => changeToFirstPage(1)}
        hidden={!checkFirstPageActive}
      >
        {1}
      </button>
      <button
        className="paginationButton"
        onClick={() => changePageBackwards(pageIndex - pageLimit)}
        hidden={pageIndex <= pageLimit}
      >
        &hellip;
      </button>

      {pageNumbers.map((pageNumber) => (
        <Fragment key={pageNumber}>
          {pageNumber < maxPageNumberLimit + 1 &&
            pageNumber > minimumPageNumberLimit && (
              <button
                key={pageNumber}
                onClick={() => changePage(pageNumber)}
                className={
                  pageIndex == pageNumber
                    ? 'paginationButton-active'
                    : 'paginationButton'
                }
              >
                {pageNumber}
              </button>
            )}
        </Fragment>
      ))}

      {pageNumbers.length > maxPageNumberLimit && (
        <button
          className="paginationButton"
          onClick={() => changePageForward(pageIndex + pageLimit)}
          hidden={pageIndex >= maxPage}
        >
          &hellip;
        </button>
      )}

      <button
        className="paginationButton"
        onClick={() => changeToLastPage(pageNumbers.length)}
        hidden={!checkLastPageActive}
      >
        {pageNumbers.length}
      </button>
      <button
        className="paginationButton"
        onClick={() => changePageForward(pageIndex + 1)}
        disabled={pageIndex >= maxPage}
      >
        {'>>'}
      </button>
    </div>
  );
};
